<template>
	<Layout>
		<Content :style="{'padding': '10px'}">
			<Breadcrumb :style="{margin: '5px 0'}">
				<BreadcrumbItem>人物管理 > <b>照片数字人列表</b></BreadcrumbItem>
			</Breadcrumb>
			<Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
				<span class="search_span_width">
					<span class="search_span_width_part1">人物ID：</span>
					<Input v-model="search.figure_id" clearable style="width: 80px" />
				</span>
				<Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getList(1)">搜索</Button>
			</Card>
			<Card>
				<Card id="tableContent" >
					<Table :columns="tableColumns" row-key="id" :data="recordList"></Table>
					<Page :total="recordTotal" :current="page" :page-size="10" @on-change="getList"/>
				</Card>
			</Card>
		</Content>
	</Layout>
</template>
<script>
import { formatDate } from '@/utils/date.js';
export default {
	data(){
		return {
			search:{
				figure_id:'',
       			make_type:3,
			},
			recordList:[],
			recordTotal:0,
			page:1,
			tableColumns:[
				{ title: '人物ID', key: 'id', align: 'center', width: 80 },
				{ title: '名称', key: 'title', align: 'center' },
				{ title: '备注', key: 'name', align: 'center' },
				{ title: '分组', key: 'group_id', align: 'center',
					render:(h,params) =>{
						return h('span',{}, params.row.group_id == 1 ? '默认' : '智慧零售');
					}
				},
				{ title: '用户ID', key: 'deduct_id', align: 'center', width: 100 },
				{ title: '用户类型', key: 'deduct_type', align: 'center',
					render:(h,params) =>{
						return h('span',{}, params.row.deduct_type == 1 ? '用户' : '代理商');
					}
				},
				{ title: '模型状态', key: 'train_status', align: 'center', width: 100 },
				{ title: '提交时间', key: 'created_at', align: 'center',
					render:(h,params) =>{
						return h('span',{}, formatDate(new Date(parseInt(params.row.created_at)*1000), 'yyyy-MM-dd hh:mm'));
					}
				}
			],
		}
	},
	mounted:function(){
		this.getList();
	},
	computed:{},
	methods:{
		getList(page=this.page) {
			this.page = page;
			let p = {'page' : page}
			let params = Object.assign(this.search, p);
			this.http.get('/admin/figure/list',{params:params}).then(response=>{
				let data=response.data;
				if(data.code!==0){
					alert(data.message);
				} else{
					this.recordList = data.data.list;
					this.recordTotal = parseInt(data.data.total);
				}
			}).catch(()=>{
				this.$Message.error('网络错误');
			});
	  	}
	}
}
</script>
